import classnames from 'classnames';
import React from 'react';

import { GraphQLTypes } from 'src/lib/graphqlTypes';

import { SummaryChangeIcon } from '../changeIcon/ChangeIcon';
import {
  TypeOfChange,
  getTypeOfChangeByChangeCodeAndTypeOfThing,
} from '../getTypeOfChangeByChangeCodeAndTypeOfThing';

export const ChangesCounters = ({
  changes,
}: {
  changes: GraphQLTypes.ChangeLogPage_service_schemaTag_history_diffToPrevious_changes[];
}) => {
  const counts: Record<TypeOfChange, number | undefined> = changes.reduce(
    (acc, change) => {
      const key = (
        ['field', 'type', 'argument'] as const
      ).reduce<TypeOfChange | null>(
        (changeType, possibleTypeOfThingChangeHappenedTo) => {
          if (changeType) {
            // already figured it out
            return changeType;
          }
          return getTypeOfChangeByChangeCodeAndTypeOfThing(
            change.code,
            possibleTypeOfThingChangeHappenedTo,
          );
        },
        null,
      );
      if (!key) return acc;
      return { ...acc, [key]: (acc[key] ?? 0) + 1 };
    },
    {} as Record<TypeOfChange, number | undefined>,
  );

  return (
    <>
      {(['ADDITION', 'REMOVAL', 'DEPRECATION', 'THIS_CHANGED'] as const).map(
        (typeOfChange) => {
          if (typeof counts[typeOfChange] !== 'number') return null;
          return (
            <div
              key={typeOfChange}
              className={classnames(
                'ml-3 flex items-center gap-1 font-semibold',
                typeOfChange === 'ADDITION' && 'text-success',
                typeOfChange === 'REMOVAL' && 'text-error',
                typeOfChange === 'THIS_CHANGED' && 'text-warning',
                typeOfChange === 'DEPRECATION' && 'text-warning',
              )}
            >
              <SummaryChangeIcon changeType={typeOfChange} />
              {counts[typeOfChange]}
            </div>
          );
        },
      )}
    </>
  );
};
